// extracted by mini-css-extract-plugin
export default {"container":"HJVrLY","placeInfoContainer":"BPja86","ticketInfoContainer":"g44OFM","ticketNameContainer":"S7MtGW","priceOptionTicketName":"NZZR25"};